<template>
  <FieldBox :title="title" class="order-quantity">
    <PlusMinusInput
      v-model="quantity"
      :max="999999999"
      :step="step"
      :min="0"
      :match-tick="true"
      :disabled="disabled"
      :placeholder="placeholder"
      :default-value="0"
    />
    <p v-if="Math.abs(positionNum) > 0" class="quantity-tip">
      {{ $t('trade.order-position-hint', [positionNum, this.unit]) }}
    </p>
    <p v-if="isHK" class="quantity-tip">
      {{ $t('trade.order-minimum-trade-size', [stock.lotSize]) }}
    </p>
    <p v-if="showLeveraged" class="quantity-tip">
      {{ leverageTip }}
    </p>
  </FieldBox>
</template>

<script>
import { mapGetters } from 'vuex'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'
import getFixedPriceWithMinTick from 'utils/getFixedPriceWithMinTick'
import { ORDER_TYPE } from 'const/trade'
export default {
  name: 'OrderQuantityField',
  components: { PlusMinusInput, FieldBox },
  props: {
    maxQuantity: Number,
    positionNum: Number,
    isLeveraged: Boolean
  },
  computed: {
    ...mapGetters(['tradeRequest', 'isCash', 'asset', 'isIb']),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    title() {
      return this.isOPT
        ? this.$t('trade.option-unit-quantity')
        : this.$t('trade.quantity')
    },
    disabled() {
      // 改单下，附加单和部分成交订单不支持修改数量
      if (this.tradeRequest.isModify) {
        return (
          [ORDER_TYPE.PROFIT, ORDER_TYPE.LOSS].includes(
            this.order.attachType
          ) || this.order.filledQuantity > 0
        )
      }
    },
    placeholder() {
      const maxQuantity = this.isHK
        ? getFixedPriceWithMinTick(this.maxQuantity, this.stock.lotSize || 1)
        : this.maxQuantity
      return this.$t('max') + (maxQuantity || '0')
    },
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    isOPT() {
      return this.stock.secType === SEC_TYPE.OPT
    },
    quantity: {
      get() {
        return this.order.totalQuantity
      },
      set(quantity) {
        this.$store.dispatch('updateTradeOrder', {
          quickPosition: null, // 快捷仓位
          totalQuantity: quantity
        })
      }
    },
    showLeveraged() {
      const isSell = this.order.action === 'SELL'

      if (this.isCash || isSell || this.positionNum < 0) return false
      if (this.isLeveraged && this.quantity) return true
      return this.maxQuantity && this.quantity > this.maxQuantity
    },
    leverageTip() {
      return this.isLeveraged
        ? this.$t('trade.leverage-grow')
        : this.$t('trade.use-leverage')
    },
    unit() {
      return this.isOPT ? this.$t('trade.option-unit') : this.$t('trade.unit')
    },
    step() {
      if (this.isHK) return this.stock.lotSize || 1
      if (this.isOPT) return 1
      if (this.quantity >= 300) return 100
      if (this.quantity >= 50) return 10
      return 1
    }
  }
}
</script>

<style>
.quantity-tip {
  margin-top: 5px;
  text-align: left;
  color: var(--active-color);
}
</style>
